/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const CancelChargeOriginalMapping = require('./cancel_charge_original_mapping').default;

class CancelChargeElement {
  static initClass() {
    this.prototype.cancelValidationError = 'キャンセル料の内容を入力してください。';

    this.prototype.timeValidationError = '利用開始以降を指定してください。';

    this.prototype.mappingsError = 'キャンセル対象を選択してください。';
  }
  constructor(args) {
    if (args == null) {
      args = {};
    }
    _.assign(this, snakeToCamelObject(args));
    this.type = 'cancel';
    if (!this.content) {
      this.content = '';
    }
    this.canceledAt = moment(args.canceledAt);
    this.startAt = moment(args.startAt).startOf('day');
    this.endAt = moment(args.endAt).endOf('day');
    this.mappings = _.map(
      args.cancelChargeOriginalMappings || args.cancel_charge_original_mappings || [],
      raw => new CancelChargeOriginalMapping(raw)
    );
  }

  handleChangeContent(value) {
    this.content = value;
    return app.render();
  }

  handleCanceledAtChange(moment) {
    this.canceledAt = moment;
    return app.render();
  }

  handleStartAtChange(moment) {
    this.startAt = moment;
    return app.render();
  }

  handleEndAtChange(moment) {
    this.endAt = moment;
    return app.render();
  }

  addMapping() {
    this.mappings.push(new CancelChargeOriginalMapping({}));
    return app.render();
  }

  removeMapping(index) {
    this.mappings.splice(index, 1);
    return app.render();
  }

  startDate() {
    return this.startAt;
  }

  endDate() {
    return this.endAt;
  }

  description() {
    return `\
<キャンセル>
■内容
${this.content}
■キャンセル日
${this.canceledAt.format('MM/DD')}\
`;
  }

  title() {
    return 'キャンセル料';
  }

  summary() {
    return this.content;
  }

  detail() {
    return '';
  }

  structuredDetail() {
    return [];
  }

  mappingDescription() {
    return this.title();
  }

  mappingsWithSettings() {
    return _.filter(this.mappings, m => m.originalTraceId);
  }

  validationErrors(_) {
    const errors = [];
    if (this.content === '') {
      errors.push(this.cancelValidationError);
    }
    if (this.endAt < this.startAt) {
      errors.push(this.timeValidationError);
    }
    if (this.mappingsWithSettings().length < 1) {
      errors.push(this.mappingsError);
    }
    return errors;
  }

  updateParams() {
    return {
      type: this.type,
      content: this.content,
      canceled_at: this.canceledAt.format('YYYY-MM-DD'),
      start_at: this.startAt.format('YYYY-MM-DD hh:mm'),
      end_at: this.endAt.format('YYYY-MM-DD hh:mm'),
      cancel_charge_original_mappings_attributes: _.map(this.mappingsWithSettings(), m => m.updateParams())
    };
  }
}
CancelChargeElement.initClass();

module.exports = CancelChargeElement;
